// libs
import { createContext, useContext } from 'react';

// types
import { ContentDetailsProps } from '@/components/ContentDetails/types';

export const ContentDetailsContext = createContext<ContentDetailsProps | null>(null);

export const useContentDetails = () => {
  const value = useContext(ContentDetailsContext);

  if (!value) {
    throw new Error('[ContentDetailsContext] Not initialised');
  }

  return value;
};
